import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { API_BASE_URL } from "../../config/baseUrls";

const OAuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [status, setStatus] = useState("Processing...");

  useEffect(() => {
    handleCallback();
  }, []);

  const handleCallback = async () => {
    try {
      const params = new URLSearchParams(location.search);
      const code = params.get("code");
      const state = params.get("state");
      const error = params.get("error");
      const provider = localStorage.getItem("oauth_provider");

      if (error) {
        setStatus("Authentication failed");
        setTimeout(() => navigate("/login"), 2000);
        return;
      }

      if (!code || !provider) {
        setStatus("Invalid authentication response");
        setTimeout(() => navigate("/login"), 2000);
        return;
      }

      setStatus(`Completing ${provider} sign-in...`);

      const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
      const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI;

      if (provider === "google") {
        const { authentication } = code;
        await sendCodeToBackend(authentication, "google");
      } else if (provider === "apple") {
        await sendCodeToBackend(code, "apple");
      }

      localStorage.removeItem("oauth_provider");
    } catch (error) {
      console.error("Callback error:", error);
      setStatus("Authentication failed");
      setTimeout(() => navigate("events/login"), 2000);
    }
  };

  const sendCodeToBackend = async (code, provider) => {
    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI;

    const response = await fetch(
      `${API_BASE_URL}/${provider}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: code,
        }),
      }
    );

    if (!response.ok) {
      throw new Error(`Backend responded with status: ${response.status}`);
    }

    const data = await response.json();

    localStorage.setItem("JWTtoken", data.token);
    localStorage.setItem("userId", data.user.cuid);

    await checkUserProfile(data.user.cuid, data.token);
  };

  const checkUserProfile = async (userId, token) => {
    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

    const response = await fetch(
      `${BACKEND_URL}/auth/getuserprod?cuid=${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const userData = await response.json();

    navigate("/events/billing");
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.spinner}></div>
        <h2 style={styles.title}>{status}</h2>
        <p style={styles.subtitle}>Please wait...</p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
  },
  card: {
    backgroundColor: "#ffffff",
    borderRadius: "24px",
    padding: "48px 40px",
    maxWidth: "400px",
    width: "100%",
    textAlign: "center",
    boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
  },
  spinner: {
    width: "60px",
    height: "60px",
    margin: "0 auto 24px",
    border: "4px solid rgba(102, 126, 234, 0.2)",
    borderTopColor: "#667eea",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
  title: {
    fontSize: "24px",
    fontWeight: "700",
    color: "#1a1a1a",
    margin: "0 0 8px 0",
  },
  subtitle: {
    fontSize: "16px",
    color: "#666",
    margin: "0",
  },
};

const styleSheet = document.styleSheets[0];
styleSheet.insertRule(
  `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`,
  styleSheet.cssRules.length
);

export default OAuthCallback;
